import styled from "@emotion/styled";

import { AdSlot } from "~/components/advertisement/ad-slots/ad-slot";
import { Loading } from "~/components/common/loading";
import { ContentItemRender } from "~/components/content/content-item-render";
import { setFullViewportWidthStyles } from "~/lib/styles";

export const Container = styled.div``;

export const Item = styled(ContentItemRender)`
  padding-block: 20px;

  & + & {
    border-block-start: 1px solid #e5e5e5;
  }
`;

export const StyledAdSlot = styled(AdSlot)`
  padding-block-end: 20px;
`;

export const AdSlotWrapper = styled.div`
  ${props => props.theme.breakpoints.only("mobile")} {
    ${setFullViewportWidthStyles()}
  }
`;

export const StyledLoading = styled(Loading)`
  padding-block-end: 60px;
`;

export const EmptyLabel = styled.div`
  margin-block-start: 20px;

  color: #666666;
  font-size: 16px;
  line-height: 130%;
`;
